import { editor, languages } from "monaco-editor/esm/vs/editor/editor.api";
import { DiagnosticMessageChain } from "typescript";

export function flattenDiagnosticMessageText(
  diagnosticMessage: string | DiagnosticMessageChain | undefined,
  newLine: string,
  indent = 0
): string {
  if (typeof diagnosticMessage === "string") {
    return diagnosticMessage;
  } else if (diagnosticMessage === undefined) {
    return "";
  }
  let result = "";
  if (indent) {
    result += newLine;

    for (let i = 0; i < indent; i++) {
      result += "  ";
    }
  }
  result += diagnosticMessage.messageText;
  indent++;
  if (diagnosticMessage.next) {
    for (const kid of diagnosticMessage.next) {
      result += flattenDiagnosticMessageText(kid, newLine, indent);
    }
  }
  return result;
}

export const revalidateModels = async () => {
  try {
    const models = editor.getModels().filter((item) => item.getLanguageId() === "typescript");
    const promises = [];
    const getWorker = await languages.typescript.getTypeScriptWorker();
    const worker = await getWorker(...models.map((model) => model.uri));

    for (const model of models) {
      promises.push(worker.getSyntacticDiagnostics(model.uri.toString()));
      //promises.push(worker.getSemanticDiagnostics(model.uri.toString()));
    }

    // const diagnostics = (
    //   await Promise.all(promises)
    // ).reduce((a, it) => a.concat(it));

    // const markers: { [uri: string]: editor.IMarkerData[] } = {};

    // for (const diag of diagnostics) {
    //   const model = models.find((model) => model.uri.toString() === diag.file?.fileName)!;
    //   const start = model.getPositionAt(diag.start!);
    //   const end = model.getPositionAt(diag.start! + diag.length!);
    //   const marker = {
    //     severity: MarkerSeverity.Error,
    //     startLineNumber: start.lineNumber,
    //     startColumn: start.column,
    //     endLineNumber: end.lineNumber,
    //     endColumn: end.column,
    //     message: flattenDiagnosticMessageText(diag.messageText, "\n")
    //   }
    //   markers[model.uri.toString()] = [...(markers[model.uri.toString()] ?? []), marker];
    // }

    // for (const uri of Object.keys(markers)) {
    //   const model = models.find((item) => item.uri.toString() === uri)!
    //   editor.setModelMarkers(model, "typescript", markers[uri]);
    // }
  } catch (error) {
    console.error(error);
  }
}
